import { createFileRoute } from "@tanstack/react-router";
import {
  analysisGroupsQueryOptions,
  analysisTypesQueryOptions,
} from "../../app/queries/productQueries";
import { ProductViewer } from "../../app/views/admin/productViewer";

export const Route = createFileRoute("/admin/productViewer")({
  component: ProductViewer,
  loader: async ({ context: { queryClient } }) => {
    queryClient.ensureQueryData(analysisGroupsQueryOptions);
    queryClient.ensureQueryData(analysisTypesQueryOptions);
  },
});
